import React, { Component } from 'react';
import LoginComponent from './okta-login/Login';
import config from './.okta.config';
import _ from 'lodash';

class SplunkLoginComponent extends Component {
  constructor (props) {
    super(props);
    _.extend(config, props.config);
  }
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <LoginComponent config={config} />
        </header>
      </div>
    );
  }
}

export default SplunkLoginComponent;
